import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon, CheckIcon } from 'lucide-react';
export function ValueStack() {
  const bonuses = [{
    title: 'Entrenamiento Mental y Rendimiento en el Fútbol Juvenil',
    value: '€14',
    image: 'https://images.unsplash.com/photo-1552674605-db6ffd4facb5?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80'
  }, {
    title: 'Checklist de Resiliencia para Después del Partido',
    value: '€12',
    image: 'https://images.unsplash.com/photo-1484480974693-6ca0a78fb36b?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80'
  }, {
    title: 'Guía de Alimentación Inteligente Antes y Después de Competir',
    value: '€14',
    image: 'https://images.unsplash.com/photo-1490645935967-10de6ba17061?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80'
  }, {
    title: 'Recetario Deportivo para Futbolistas',
    value: '€12',
    image: 'https://images.unsplash.com/photo-1466637574441-749b8f19452f?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80'
  }, {
    title: 'Manual del Padre que Acompaña al Futbolista con Inteligencia',
    value: '€14',
    image: 'https://images.unsplash.com/photo-1536104968055-4d61aa56f46a?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80'
  }, {
    title: 'Diario de Progreso y Entrenamiento del Futbolista',
    value: '€12',
    image: 'https://images.unsplash.com/photo-1517842645767-c639042777db?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80'
  }, {
    title: 'Guía del Vestuario: Mentalidad, Convivencia y Actitud',
    value: '€14',
    image: 'https://images.unsplash.com/photo-1431324155629-1a6deb1dec8d?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80'
  }, {
    title: 'Historias de Superación en el Fútbol',
    value: '€12',
    image: 'https://images.unsplash.com/photo-1574629810360-7efbbe195018?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80'
  }, {
    title: 'Guía principal: Cómo Despertar el Amor por el Fútbol en tu Hijo',
    value: '€14',
    image: 'https://images.unsplash.com/photo-1596464716127-f2a82984de30?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80'
  }];
  const totalValue = 118;
  return <section className="py-20 md:py-28 bg-white" data-id="element-249">
      <div className="max-w-3xl mx-auto px-5 sm:px-6 lg:px-8" data-id="element-250">
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="text-center mb-12 md:mb-16" data-id="element-251">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-[#f8f9fa] mb-6" data-id="element-252">
            <GiftIcon className="w-6 h-6 text-brand-slate" data-id="element-253" />
          </div>
          <h2 className="text-3xl md:text-4xl font-heading text-brand-slate mb-4 leading-tight" data-id="element-254">
            Además vas a recibir estos{' '}
            <span className="text-brand-amber" data-id="element-255">bonos exclusivos:</span>
          </h2>
          <p className="text-base md:text-lg text-brand-slate-light leading-relaxed" data-id="element-256">
            Complementos diseñados para potenciar los resultados de la guía
            principal.
          </p>
        </motion.div>

        <div className="space-y-4 mb-16" data-id="element-257">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className="flex flex-row items-center p-4 md:p-5 bg-white rounded-2xl border border-gray-100 gap-4" data-id="element-258">
              <div className="flex-shrink-0 w-16 h-16 sm:w-20 sm:h-20 rounded-xl overflow-hidden border border-gray-50" data-id="element-259">
                <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover" data-id="element-260" />
              </div>
              <div className="flex-grow min-w-0" data-id="element-261">
                <h4 className="text-base sm:text-lg font-medium text-brand-slate leading-tight mb-1" data-id="element-262">
                  {bonus.title}
                </h4>
                <p className="text-xs sm:text-sm text-brand-slate-muted flex items-center" data-id="element-263">
                  <CheckIcon className="w-3.5 h-3.5 text-brand-amber mr-1.5 flex-shrink-0" data-id="element-264" />
                  Incluido gratis hoy
                </p>
              </div>
              <div className="flex-shrink-0 text-right ml-2" data-id="element-265">
                <span className="text-xs text-brand-slate-muted uppercase tracking-wide font-medium block mb-0.5" data-id="element-266">
                  Valor
                </span>
                <span className="text-base sm:text-lg font-medium text-brand-slate-muted line-through" data-id="element-267">
                  {bonus.value}
                </span>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="bg-[#1a1a2e] text-white rounded-2xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-268">
          <h3 className="text-2xl md:text-3xl font-heading mb-8 leading-tight" data-id="element-269">
            Resumen de tu Inversión
          </h3>

          <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-16 mb-8" data-id="element-270">
            <div data-id="element-271">
              <p className="text-white/60 text-xs uppercase tracking-wide mb-2" data-id="element-272">
                Valor Total Real
              </p>
              <p className="text-3xl md:text-4xl font-medium text-white/40 line-through" data-id="element-273">
                €{totalValue}
              </p>
            </div>
            <div className="hidden md:block w-px h-12 bg-white/10" data-id="element-274"></div>
            <div data-id="element-275">
              <p className="text-brand-amber font-medium text-xs uppercase tracking-wide mb-2" data-id="element-276">
                Precio Especial Hoy
              </p>
              <p className="text-4xl md:text-5xl font-heading text-white" data-id="element-277">
                €17.99
              </p>
            </div>
          </div>

          <p className="text-white/80 text-base md:text-lg" data-id="element-278">
            Te llevas todo el paquete con un{' '}
            <strong className="text-white font-medium" data-id="element-279">70% de descuento</strong>
            .
          </p>
        </motion.div>
      </div>
    </section>;
}